import React from 'react';
import PropTypes from 'prop-types';

export function ContactRoleGroups({ groupComponent, readOnly, relationshipGroups }) {
  const GroupComponent = groupComponent;
  return (
    <React.Fragment>
      {relationshipGroups.map((group, i) => {
        return (
          <GroupComponent
            availableRelationships={group.availableRelationships}
            contactLabel={group.contactLabel}
            key={i}
            readOnly={readOnly}
            required={group.required}
            showAllExcept={group.showAllExcept}
            title={group.title}
          />
        );
      })}
    </React.Fragment>
  );
}

ContactRoleGroups.propTypes = {
  groupComponent: PropTypes.any.isRequired,
  readOnly: PropTypes.bool,
  relationshipGroups: PropTypes.arrayOf(PropTypes.shape({
    availableRelationships: PropTypes.array,
    contactLabel: PropTypes.string,
    required: PropTypes.bool,
    showAllExcept: PropTypes.array,
    title: PropTypes.string,
  })).isRequired,
};

export default ContactRoleGroups;
